import React, { Component } from "react";
import PropTypes from "prop-types";

class Phone extends Component {
	onClick = () => {
		const { onSelect, itemKey } = this.props;
		if (onSelect) {
			onSelect(itemKey);
		}
	};

	encode = string => {
		var number = "";
		var length = string.length;
		for (var i = 0; i < length; i++) number += string.charCodeAt(i).toString(10);
		return number;
	};
	render() {
		let colors = [
			"rgba(68, 255, 255, 1)",
			"rgba(0, 115, 184, 1)",
			"rgba(41, 47, 193, 1)",
			"rgba(10, 0, 60, 1)",
			"rgba(0, 115, 184, 1)",
			"rgba(41, 47, 193, 1)",
			"rgba(10, 0, 60, 1)",
		];
		let style = {
			backgroundImage: `url('https://source.unsplash.com/random/600x800/?nature&rand=${this.props.itemKey}')`,
		};
		if (this.props.backgroundImage) {
			style = { backgroundImage: `url('${this.props.backgroundImage}')` };
		} else if (this.props.itemKey) {
			style = { backgroundColor: colors[this.encode(this.props.itemKey) % colors.length] };
		}

		return (
			<div className="phone-object" onClick={this.onClick}>
				<div className="phone">
					<div className="phone-body">
						<div className="phone-screen" style={style}></div>
					</div>
					<div className="phone-top"></div>
					<div className="phone-back"></div>
					<div className="phone-bottom"></div>
				</div>
				<h4 className="title">{this.props.name}</h4>
			</div>
		);
	}
}
Phone.propTypes = {
	name: PropTypes.string,
	onSelect: PropTypes.func,
	itemKey: PropTypes.string,
	backgroundImage: PropTypes.string,
};
export default Phone;
